module.exports = __webpack_public_path__ + "static/media/Navin Bharwani.04391842.jpg";